/**
 * Enhanced CartCount behavior that filters out buno + products
 * This patches the existing CartCount custom elements with filtering logic
 */
(function() {
  'use strict';

  // Wait for theme pubsub to be available
  function initializeFilteredCartCount() {
    if (!window.theme?.pubsub) {
      setTimeout(initializeFilteredCartCount, 100);
      return;
    }

    /**
     * Calculate filtered item count by subtracting buno + products
     */
    function calculateFilteredCount(cartData, bunoPlusProductId) {
      if (!bunoPlusProductId || !cartData.items) {
        return cartData.item_count;
      }

      const productId = parseInt(bunoPlusProductId);
      let bunoPlusItemsCount = 0;

      // Count buno + items in cart
      cartData.items.forEach(item => {
        if (item.product_id === productId) {
          bunoPlusItemsCount += item.quantity;
        }
      });

      return Math.max(0, cartData.item_count - bunoPlusItemsCount);
    }

    /**
     * Enhanced cart update handler for filtered cart counts
     */
    function handleFilteredCartUpdate(event) {
      const filteredCartCounts = document.querySelectorAll('cart-count[data-buno-plus-filtered="true"]');
      
      if (filteredCartCounts.length === 0 || event.cart.errors) {
        return;
      }

      filteredCartCounts.forEach(element => {
        const bunoPlusProductId = element.getAttribute('data-buno-plus-product-id');
        const filteredCount = calculateFilteredCount(event.cart, bunoPlusProductId);
        
        element.innerText = filteredCount;
        element.hidden = filteredCount === 0;

        // Update aria-label for accessibility
        const ariaLabel = element.getAttribute('aria-label');
        if (ariaLabel) {
          const updatedAriaLabel = ariaLabel.replace(/\(\d+\)/, `(${filteredCount})`);
          element.setAttribute('aria-label', updatedAriaLabel);
        }
      });
    }

    /**
     * Initialize filtered counts on page load
     */
    async function initializeFilteredCounts() {
      const filteredCartCounts = document.querySelectorAll('cart-count[data-buno-plus-filtered="true"]');
      
      if (filteredCartCounts.length === 0) {
        return;
      }

      try {
        const response = await fetch(window.Shopify?.routes?.root + 'cart.js');
        if (response.ok) {
          const cartData = await response.json();
          
          filteredCartCounts.forEach(element => {
            const bunoPlusProductId = element.getAttribute('data-buno-plus-product-id');
            const filteredCount = calculateFilteredCount(cartData, bunoPlusProductId);
            
            element.innerText = filteredCount;
            element.hidden = filteredCount === 0;
          });
        }
      } catch (error) {
        console.warn('Failed to initialize filtered cart counts:', error);
      }
    }

    // Subscribe to cart update events
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, handleFilteredCartUpdate);

    // Initialize counts on page load
    initializeFilteredCounts();

    // Also watch for new filtered cart count elements being added to the DOM
    const observer = new MutationObserver(mutations => {
      let hasNewFilteredElements = false;
      
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'CART-COUNT' && node.hasAttribute('data-buno-plus-filtered')) {
              hasNewFilteredElements = true;
            }
            // Also check child elements
            const childFiltered = node.querySelectorAll?.('cart-count[data-buno-plus-filtered="true"]');
            if (childFiltered?.length > 0) {
              hasNewFilteredElements = true;
            }
          }
        });
      });

      if (hasNewFilteredElements) {
        // Re-initialize counts for new elements
        setTimeout(initializeFilteredCounts, 10);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    console.log('✅ Filtered cart count system initialized');
  }

  // Initialize when DOM and theme are ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFilteredCartCount);
  } else {
    initializeFilteredCartCount();
  }
})();